/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Document } from '../../models/document';

export interface DocumentsAdminControllerCreate$Params {
      body: {
'identifier'?: string;
'name'?: string;
'nameEn'?: string;
'path'?: string;
'pathEn'?: string;
'isActive'?: boolean;
'file'?: Blob;
'fileEn'?: Blob;
}
}

export function documentsAdminControllerCreate(http: HttpClient, rootUrl: string, params: DocumentsAdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Document>> {
  const rb = new RequestBuilder(rootUrl, documentsAdminControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Document>;
    })
  );
}

documentsAdminControllerCreate.PATH = '/admin/documents';
